// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".line-clamp{display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical;transition:offsetHeight 1s ease;transition:height 1s ease}.clamp-1{-webkit-line-clamp:1}.clamp-2{-webkit-line-clamp:2}.clamp-3{-webkit-line-clamp:3}.clamp-4{-webkit-line-clamp:4}.clamp-5{-webkit-line-clamp:5}.clamp-6{-webkit-line-clamp:6}.clamp-7,.clamp-8,.clamp-9{-webkit-line-clamp:7}.clamp-10{-webkit-line-clamp:10}.clamp-11{-webkit-line-clamp:11}.clamp-12{-webkit-line-clamp:12}.clamp-14{-webkit-line-clamp:14}.clamp-20{-webkit-line-clamp:20}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
